/* eslint-disable react/prop-types */
import React, { memo, useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { CanvasWidget } from "@projectstorm/react-canvas-core";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "./Components/sidebar/SideMenu";

const { isSuperadmin } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

function MainWindow({
  addChild,
  engine,
  redistribute,
  zoomToFit,
  saveProject,
  zoomToSelected,
  resetLayout,
}) {
  const [animatd, setAnimatd] = useState(false); // animation during zoom
  const refreshDiagramGeometry = useCallback(() => {
    const canvas = engine?.getCanvas?.();

    if (!canvas?.offsetWidth || !canvas?.offsetHeight) {
      return;
    }

    const model = engine?.getModel?.() || engine?.model;

    (model?.getNodes?.() || []).forEach((node) => {
      Object.values(node.getPorts?.() || {}).forEach((port) => {
        if (port?.reportedPosition) {
          port.reportPosition?.();
        }
      });
    });

    engine?.repaintCanvas?.();
  }, [engine]);

  useEffect(() => {
    let isCancelled = false;
    const refresh = () => {
      if (!isCancelled) {
        refreshDiagramGeometry();
      }
    };

    const firstFrame = requestAnimationFrame(() => {
      refresh();
      requestAnimationFrame(refresh);
    });
    const delayedRefresh = setTimeout(refresh, 150);

    return () => {
      isCancelled = true;
      cancelAnimationFrame(firstFrame);
      clearTimeout(delayedRefresh);
    };
  }, [refreshDiagramGeometry]);

  const handleCanvasDoubleClick = useCallback(() => {
    setAnimatd(true);
    setTimeout(() => {
      setAnimatd(false);
    }, 300);
    zoomToSelected();
  }, [zoomToSelected]);

  return (
    <div
      className="main-window position-relative mb-n5"
      style={{
        height: isSuperadmin ? "calc(100vh - 160px)" : "calc(100vh - 140px)",
        display: "flex",
      }}
    >
      <SideMenu
        addChild={addChild}
        redistribute={redistribute}
        saveProject={saveProject}
        zoomToFit={zoomToFit}
        zoomToSelected={zoomToSelected}
        resetLayout={resetLayout}
      />
      <div
        style={{ flexGrow: 1, position: "relative" }}
        onDoubleClick={handleCanvasDoubleClick}
      >
        <CanvasWidget
          className={`bg-loop bg-accross diagram-container ${
            animatd ? " animated" : ""
          } `}
          engine={engine}
        />
      </div>
      <div id="sidebar" style={{ overflow: "auto", position: "relative" }} />
      <Outlet />
    </div>
  );
}

export default memo(MainWindow);
